import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: "Connect to Hubble's MCP server.",
    desc: 'One integration gives your agent access to EHRs, payers, clearinghouses, labs, and pharmacy networks.'
  }, {
    num: '02',
    title: 'Define agent identity and permissions.',
    desc: 'Use the portal to scope what each agent can read, write, and act on. HIPAA-grade access controls from the start.'
  }, {
    num: '03',
    title: 'Ship to production.',
    desc: 'Go live with audit trails, observability, and quality monitoring built in. No extra infrastructure required.'
  }];
  return <section id="how-it-works" className="py-24 relative z-10" data-id="element-51">
      <div className="max-w-7xl mx-auto px-6" data-id="element-52">
        <div className="text-center mb-16" data-id="element-53">
          <span className="text-hubble-accent text-[12px] md:text-[14px] font-body font-medium tracking-[3px] uppercase mb-4 block" data-id="element-54">
            HOW IT WORKS
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-normal tracking-[-1px] text-hubble-text mb-6" data-id="element-55">
            From prototype to production in days, not months.
          </h2>
          <p className="font-body text-[16px] md:text-[18px] text-hubble-body max-w-3xl mx-auto leading-[1.6]" data-id="element-56">
            Every healthcare AI team rebuilds the same infrastructure before
            they can ship a production agent: integrations across fragmented
            data, HIPAA-grade governance, and quality monitoring for autonomous
            actions. Hubble replaces it with one integration.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-57">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-hubble-card border border-hubble-border rounded-2xl p-8 hover:border-hubble-primary/50 transition-colors group relative overflow-hidden" data-id="element-58">
              <div className="absolute inset-0 bg-gradient-to-br from-hubble-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-59"></div>

              <div className="font-body text-sm font-medium text-hubble-primary mb-6" data-id="element-60">
                Step {step.num}
              </div>
              <h3 className="font-heading text-xl font-medium text-hubble-text mb-4" data-id="element-61">
                {step.title}
              </h3>
              <p className="font-body text-[16px] text-hubble-body leading-[1.6]" data-id="element-62">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}